import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ValForgotPasswordComponent } from './components/val-forgot-password.component';
import { ValLoginComponent } from './components/val-login.component';
import { ValCategoryLookupResolver } from './services/val-category-lookup.resolver';
import { ValCompanyResolver } from './services/val-company.resolver';
import { ValPosLookupResolver } from './services/val-pos-lookup.resolver';


const routes: Routes = [
  {
    path: 'login',
    component: ValLoginComponent
  },
  {
    path: 'forgotpassword',
    component: ValForgotPasswordComponent
  },
  {
    path: '',
    resolve: [ValCategoryLookupResolver, ValPosLookupResolver, ValCompanyResolver],
    children: [
      {
        path: 'user',
        loadChildren: () => import('./modules/user/val-user.module').then(m => m.ValUserModule),
      },
      {
        path: '',
        loadChildren: () => import('./modules/cart/val-cart.module').then(m => m.ValCartModule),
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'prefix'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
